import { useEdiMessageTypesQuery, IEdiMessageTypesQueryVariables } from '../graphql/EdiMessageTypes'
import { processEdiMessageTypes } from '../utils'

export const useEdiMessageType = ({
  connectionConfigIds,
  connectionConfigType,
}: IEdiMessageTypesQueryVariables) => {
  const { data, loading } = useEdiMessageTypesQuery({
    variables: {
      connectionConfigType,
      connectionConfigIds,
    },
    // don't run query if either value is null TODO: better way to prevent this?
    skip: !(connectionConfigType && connectionConfigIds),
  })

  const ediMessageTypes = processEdiMessageTypes(data)

  return {
    ediMessageTypes,
    loading,
  }
}
